// extracted by mini-css-extract-plugin
export default {"videoPreview":"style-module__hv8m4","closeIcon":"style-module__vWv5u"};